"use client";

import React from "react";
import { CircleCheck, Loader, ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InicieSuaTransformacao() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="1188" id="fale-com-um-especialista" ref={ref} className={`dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_800px_at_50%_50%,_var(--color-primary)_0%,_transparent_40%)] opacity-10 blur-3xl" />
      
      <div className="container relative mx-auto px-4">
        <div className="mx-auto max-w-lg">
          {}
          <div className="mb-8 flex justify-center">
            <Badge variant="outline" className="bg-background/50 backdrop-blur-sm border-primary/30 text-primary px-4 py-1.5 text-sm font-mono font-normal tracking-wider">
              <ShieldCheck className="mr-2 size-4" />
              CONTABILIDADE ESPECIALIZADA NA IRLANDA
            </Badge>
          </div>

          <div className="relative rounded-2xl border border-white/10 bg-card/40 p-8 shadow-2xl backdrop-blur-xl md:p-12">
            <div className="mb-8 text-center">
              <h2 className="text-3xl font-bold tracking-tight text-white !font-sans md:text-4xl">Fale com um Especialista</h2>
              <p className="mt-2 text-muted-foreground font-sans">
                Evite multas e garanta sua tranquilidade fiscal na Irlanda com suporte em português.
              </p>
            </div>

            <FormProvider formId="contato_especialista_krb" sectionName="closing-section" defaultValues={{
            nome: "",
            email: "",
            empresa: "",
            cargo: "",
            telefone: ""
          }} validationRules={{
            nome: {
              required: true,
              minLength: 2,
              maxLength: 100
            },
            email: {
              required: true,
              pattern: "email"
            },
            empresa: {
              required: true,
              minLength: 2,
              maxLength: 150
            },
            cargo: {
              required: false
            },
            telefone: {
              required: false,
              pattern: "phone"
            }
          }} submitText="SOLICITAR CONSULTORIA" successMessage="Mensagem enviada com sucesso! Nossa equipe entrará em contato em breve." errorMessage="Ocorreu um erro ao enviar. Por favor, tente novamente via WhatsApp.">
              <TransformationForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}
function TransformationForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center space-y-4 py-12 text-center animate-in fade-in zoom-in duration-500">
        <div className="flex size-16 items-center justify-center rounded-full bg-primary/20 text-primary">
          <CircleCheck className="size-8" />
        </div>
        <h3 className="text-xl font-semibold text-white">Solicitação Recebida!</h3>
        <p className="text-muted-foreground">{successMessage}</p>
        <Button variant="outline" className="mt-4 border-primary/50 text-primary hover:bg-primary/10 hover:text-primary rounded-full px-8" onClick={() => window.location.reload()}>
          Voltar ao início
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="nome" render={({
      field
    }) => <FormItem className="relative space-y-0">
            <FormControl>
              <Input {...field} placeholder=" " className="peer block w-full border-0 border-b border-border bg-transparent px-0 py-2.5 text-base text-foreground focus-visible:border-primary focus-visible:ring-0 focus-visible:outline-none md:text-sm" />
            </FormControl>
            <FormLabel className="absolute top-3 left-0 -z-10 origin-[0] -translate-y-6 scale-75 transform text-sm text-muted-foreground duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:start-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:text-primary">
              Nome Completo
            </FormLabel>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" render={({
      field
    }) => <FormItem className="relative space-y-0">
            <FormControl>
              <Input {...field} type="email" placeholder=" " className="peer block w-full border-0 border-b border-border bg-transparent px-0 py-2.5 text-base text-foreground focus-visible:border-primary focus-visible:ring-0 focus-visible:outline-none md:text-sm" />
            </FormControl>
            <FormLabel className="absolute top-3 left-0 -z-10 origin-[0] -translate-y-6 scale-75 transform text-sm text-muted-foreground duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:start-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:text-primary">
              E-mail para Contato
            </FormLabel>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="empresa" render={({
      field
    }) => <FormItem className="relative space-y-0">
            <FormControl>
              <Input {...field} placeholder=" " className="peer block w-full border-0 border-b border-border bg-transparent px-0 py-2.5 text-base text-foreground focus-visible:border-primary focus-visible:ring-0 focus-visible:outline-none md:text-sm" />
            </FormControl>
            <FormLabel className="absolute top-3 left-0 -z-10 origin-[0] -translate-y-6 scale-75 transform text-sm text-muted-foreground duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:start-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:text-primary">
              Nome da Empresa ou Atividade
            </FormLabel>
            <FormMessage />
          </FormItem>} />

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <FormField control={control} name="cargo" render={({
        field
      }) => <FormItem className="relative space-y-0">
              <FormControl>
                <Input {...field} placeholder=" " className="peer block w-full border-0 border-b border-border bg-transparent px-0 py-2.5 text-base text-foreground focus-visible:border-primary focus-visible:ring-0 focus-visible:outline-none md:text-sm" />
              </FormControl>
              <FormLabel className="absolute top-3 left-0 -z-10 origin-[0] -translate-y-6 scale-75 transform text-sm text-muted-foreground duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:start-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:text-primary">
                Serviço de Interesse
              </FormLabel>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="telefone" render={({
        field
      }) => <FormItem className="relative space-y-0">
              <FormControl>
                <Input {...field} type="tel" placeholder=" " className="peer block w-full border-0 border-b border-border bg-transparent px-0 py-2.5 text-base text-foreground focus-visible:border-primary focus-visible:ring-0 focus-visible:outline-none md:text-sm" />
              </FormControl>
              <FormLabel className="absolute top-3 left-0 -z-10 origin-[0] -translate-y-6 scale-75 transform text-sm text-muted-foreground duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:start-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:text-primary">
                WhatsApp / Telefone
              </FormLabel>
              <FormMessage />
            </FormItem>} />
      </div>

      {submitError && <div className="rounded-md bg-destructive/10 p-3 text-sm text-destructive">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-primary py-7 text-base font-bold tracking-widest text-primary-foreground shadow-[0_0_20px_rgba(234,179,8,0.2)] transition-all hover:bg-primary/90 hover:shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:-translate-y-0.5 rounded-full">
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            ENVIANDO...
          </> : <>
            SOLICITAR CONSULTORIA
            <ArrowRight className="ml-2 size-5" />
          </>}
      </Button>
      
      <p className="text-center text-xs text-muted-foreground/60 font-sans">
        Seus dados estão protegidos. Ao enviar, você concorda com nossa Política de Privacidade.
      </p>
    </Form>;
}